<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div class="table-agile-info">
            <div class="common-new-title mode2">
              <span>高考日语订单</span>
            </div>
            <div class="info-manag-wrap">
              <el-row>
                <el-col :span="6">
                  <label>订单编号:</label>
                  <span>{{ formData.sign_order_no }}</span>
                </el-col>
                <el-col :span="6">
                  <label>订单名称:</label>
                  <span>{{ formData.title }}</span>
                </el-col>
                <el-col :span="6">
                  <label>缴费时间:</label>
                  <span>{{ formData.last_payment_time }}</span>
                </el-col>
                <el-col :span="6">
                  <label>期数/当期:</label>
                  <span>{{ formData.all_stages ? formData.all_stages + '/' : '' }}{{ formData.current_stage }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <label>合同金额:</label>
                  <span>{{ formData.contract_fee }}</span>
                </el-col>
                <el-col :span="6">
                  <label>应交金额:</label>
                  <span>{{ formData.need_fee }}</span>
                </el-col>
                <el-col :span="6">
                  <label>实付金额:</label>
                  <span>{{ formData.paid_fee }}</span>
                </el-col>
                <el-col :span="6">
                  <label>退款金额:</label>
                  <span>{{ formData.refund_fee }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <label>补课课时:</label>
                  <span>{{ formData.tutoring_num }}</span>
                </el-col>
                <el-col :span="6">
                  <label>1v1课时:</label>
                  <span>{{ formData.class1v1_num }}</span>
                </el-col>
                <el-col :span="6">
                  <label>备注:</label>
                  <span>{{ formData.memo }}</span>
                </el-col>
              </el-row>
            </div>
            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>商品列表</span>
            </div>
            <el-table :data="formData.goods_list">
              <el-table-column prop="goods_id" label="商品编号" />
              <el-table-column prop="goods_type_str" label="商品类目" />
              <el-table-column prop="goods_name" label="商品名称" />
              <el-table-column prop="tutoring_num" label="补课课时" />
              <el-table-column prop="class1v1_num" label="1v1课时" />
              <el-table-column prop="original_money" label="原价" />
              <el-table-column prop="discount" label="折扣率" />
              <el-table-column prop="goods_num" label="数量" />
              <el-table-column prop="real_money" label="单价" />
              <el-table-column prop="need_fee" label="应收金额" />
              <el-table-column prop="contract_fee" label="合同金额" />
            </el-table>
            <!--列表部分 end-->
            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>支付记录</span>
            </div>
            <jm-tableList
              ref="payTable"
              :url="getPayListurl"
              :search-data="searchData"
            >
              <el-table-column
                slot="title"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.title" placement="left">
                    <span>{{ props.row.title }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                slot="memo"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.memo" placement="left">
                    <span>{{ props.row.memo }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column slot="confirm_time" label="到账日期">
                <a slot-scope="scope" @click="editConfirmTime(scope.row)">
                  {{ scope.row.confirm_time }}
                </a>
              </el-table-column>
              <el-table-column
                slot="finance_message"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.finance_message" placement="left">
                    <span>{{ props.row.finance_message }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                fixed="right"
                header-align="center"
                align="center"
                width="150"
                label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    :loading="btnLoading"
                    @click="openAccountDialog(scope.row)"
                    size="small">报账文本</el-button>
                  <el-button
                    v-if="$hasPermission(171)"
                    type="primary"
                    v-show="Number(scope.row.finance_status) === 0 || Number(scope.row.finance_status) === 1"
                    @click="confirmTrade(scope.row)"
                    size="small">到账确认</el-button>
                  <el-button
                    v-if="$hasPermission(171)"
                    type="danger"
                    v-show="Number(scope.row.finance_status) === 0"
                    @click="refuseTrade(scope.row)"
                    :loading="btnLoading"
                    size="small">拒绝</el-button>
                </template>
              </el-table-column>
            </jm-tableList>
            <!--列表部分 end-->
            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>退款记录</span>
            </div>
            <jm-tableList
              ref="refundTable"
              :url="getListurl"
              :search-data="searchData"
            >
              <el-table-column
                slot="memo"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.memo" placement="left">
                    <span>{{ props.row.memo }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                slot="examine_message"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.examine_message" placement="left">
                    <span>{{ props.row.examine_message }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                fixed="right"
                align="center"
                header-align="center"
                width="150"
                label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="success"
                    @click="openProcessDialog(scope.row)"
                    size="small">查看流程单</el-button>
                  <el-button
                    type="primary"
                    v-show="checkRefund(scope.row, 0)"
                    @click="openRefundDialog(scope.row)"
                    size="small">退款审核</el-button>
                  <el-button
                    v-show="checkRefund(scope.row, 1)"
                    type="primary"
                    @click="openRefundDateDialog(scope.row)"
                    size="small">设置退款日期</el-button>
                </template>
              </el-table-column>
            </jm-tableList>
            <!--列表部分 end-->
          </div>
          <!--报账文本弹窗 start-->
          <el-dialog
            title="报账内容"
            :visible.sync="dialogAccountLock"
            width="600px"
            :show-close="false">
            <div style="white-space: pre-wrap; max-height: 400px; overflow-y: auto" v-html="accountText"></div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogClose(1)">确 定</el-button>
            </span>
          </el-dialog>
          <!--报账文本弹窗 end-->
          <!--到账确认弹窗 start-->
          <el-dialog
            :title="onlyUpdateConfirmTime ? '修改到账日期' : '到账确认'"
            :visible.sync="dialogConfirmLock"
            width="600px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="到账日期：">
                    <el-date-picker
                      v-model="confirmTime"
                      type="date"
                      value-format="timestamp"
                      placeholder="选择到账日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(3)">取 消</el-button>
              <el-button type="primary" :loading="btnLoading" :disabled="!confirmTime" @click="saveConfirmDialog">确 定</el-button>
            </span>
          </el-dialog>
          <!--到账确认弹窗 start-->
          <!--拒绝弹窗 start-->
          <el-dialog
            title="拒绝信息"
            :visible.sync="dialogRefuseLock"
            width="600px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="财务备注：">
                    <el-input
                      type="textarea"
                      :rows="4"
                      resize="none"
                      placeholder="请输入内容"
                      v-model="refuseText">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(2)">取 消</el-button>
              <el-button type="primary" :loading="btnLoading" @click="saveRefuseDialog">确 定</el-button>
            </span>
          </el-dialog>
          <!--拒绝弹窗 end-->
          <!--退款信息弹窗 start-->
          <el-dialog
            title="退款审核"
            :visible.sync="refundDialogLock"
            width="600px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="支付方式：">
                    <span>{{ refundForm.payment_method }}</span>
                  </el-form-item>
                  <el-form-item label="退款账号：">
                    <span>{{ refundForm.payment_account }}</span>
                  </el-form-item>
                  <el-form-item label="退款金额：">
                    <span>{{ refundForm.total_amount }}</span>
                  </el-form-item>
                  <el-form-item label="退款备注：">
                    <span>{{ refundForm.memo }}</span>
                  </el-form-item>
                  <el-form-item label="审核备注：">
                    <el-input
                      type="textarea"
                      :rows="4"
                      resize="none"
                      placeholder="请输入内容"
                      v-model="refundForm.examine_message">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(4)">取 消</el-button>
              <el-button type="primary" @click="refundInfoSave" :loading="btnLoading">同 意</el-button>
              <el-button type="danger" @click="refundInfoRefuse" :loading="btnLoading">驳 回</el-button>
            </span>
          </el-dialog>
          <!--退款信息弹窗 end-->
          <!--退款日期弹窗 start-->
          <el-dialog
            title="退款日期设置"
            :visible.sync="refundDateDialogLock"
            width="600px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="支付方式：">
                    <span>{{ refundDateForm.payment_method }}</span>
                  </el-form-item>
                  <el-form-item label="退款账号：">
                    <span>{{ refundDateForm.payment_account }}</span>
                  </el-form-item>
                  <el-form-item label="退款金额：">
                    <span>{{ refundDateForm.total_amount }}</span>
                  </el-form-item>
                  <el-form-item label="退款备注：">
                    <span>{{ refundDateForm.memo }}</span>
                  </el-form-item>
                  <el-form-item label="退款日期：">
                    <el-date-picker
                      v-model="refundDateForm.refund_date"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(5)">取 消</el-button>
              <el-button type="primary" :loading="btnLoading" @click="refundDateSave">修 改</el-button>
              <el-button type="danger" :loading="btnLoading" @click="refundDateRefuse">驳 回</el-button>
            </span>
          </el-dialog>
          <!--退款日期弹窗 end-->
          <!--流程单弹窗 start-->
          <el-dialog
            title="退款流程单"
            :visible.sync="processDialogLock"
            @cancel="processDialogCancel"
            width="795px"
          >
            <div style="max-height: 500px; overflow-y: auto">
              <div class="process-dialog-wrap" id="printProcess" ref="printContent">
                <div class="title-area">
                  <h3>退款流程单</h3>
                  <i>退款编号：{{ processForm.id }}</i>
                </div>
                <div class="process-dialog-area">
                  <div class="content-area">
                    <span></span>
                    <span></span>
                  </div>
                  <div class="content-area">
                    <span>财务总监签字：</span>
                    <span></span>
                  </div>
                  <div class="content-area">
                    <span>退款发起人：</span>
                    <span>{{ processForm.pub_teacher }}</span>
                  </div>
                  <div class="content-area">
                    <span>申请时间：</span>
                    <span>{{ processForm.create_time }}</span>
                  </div>
                  <div class="content-area">
                    <span>姓名：</span>
                    <span>{{ processForm.pub_account }}</span>
                  </div>
                  <div class="content-area">
                    <span>学校：</span>
                    <span>{{ processForm.school_name }}</span>
                  </div>
                  <div class="content-area">
                    <span>退款方式：</span>
                    <span>{{ processForm.payment_method }}</span>
                  </div>
                  <div class="content-area">
                    <span>联系电话：</span>
                    <span>{{ processForm.pub_telphone }}</span>
                  </div>
                  <div class="content-area">
                    <span>退款金额：</span>
                    <span>{{ processForm.total_amount }}（元）</span>
                  </div>
                  <div class="content-area">
                    <span>退款账户：</span>
                    <span>{{ processForm.payment_account }}</span>
                  </div>
                  <div class="content-area large-size">
                    <span>备注：</span>
                    <span>{{ processForm.memo }}</span>
                  </div>
                </div>
                <el-table class="tableList printTable" :data="processForm.log_list">
                  <el-table-column
                    width="120px"
                    prop="examine_function"
                    label="审核人职能">
                  </el-table-column>
                  <el-table-column
                    width="120px"
                    prop="examine_name"
                    label="姓名">
                  </el-table-column>
                  <el-table-column
                    width="120px"
                    prop="create_time"
                    label="审核时间">
                  </el-table-column>
                  <el-table-column
                    width="90px"
                    prop="examine_status_str"
                    label="审核结果">
                  </el-table-column>
                  <el-table-column
                    prop="examine_message"
                    label="审核备注">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <template slot="footer">
              <el-button
                size="small"
                type="primary"
                v-print="printObj">打印</el-button>
            </template>
          </el-dialog>
          <!--流程单弹窗 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
      formData: {
        goods_list: []
      },
      searchData: {
        isOrderDetail: true,
        order_id: this.$route.params.id,
        project_id: 10
      },
      dialogAccountLock: false, // 报账文本弹窗锁
      dialogRefuseLock: false, // 拒绝报账弹窗锁
      dialogConfirmLock: false, // 到账确认弹窗锁
      accountText: '', // 报账文本弹窗内容
      refuseText: '', // 拒绝弹窗文本
      currentRowId: '', // 拒绝弹窗id
      selectDict: {}, // 下拉框字典
      refundDialogLock: false, // 退款信息弹窗锁
      getListurl: '/finance/refund/pagetable',
      getPayListurl: '/finance/trade/pagetable',
      refundForm: {}, // 退款信息弹窗内容
      refundDateForm: {}, // 退款日期弹窗表单
      refundDateDialogLock: false, // 退款日期弹窗锁
      processDialogLock: false, // 流程单弹窗锁
      processForm: {}, // 流程单变量
      printObj: {
        id: 'printProcess',
        popTitle: '昆仑系统-退款流程单'
      },
      confirmTime: null, // 到账日期
      onlyUpdateConfirmTime: false, // 只更新时间
      btnLoading: false
    };
  },
  computed: {
    id () {
      if (this.$route.params === undefined) {
        return false;
      }
      return this.$route.params.id;
    }
  },
  methods: {
    // 关闭弹窗
    dialogClose(check) {
      switch (check) {
        case 1:
          this.dialogAccountLock = false;
          break;
        case 2:
          this.dialogRefuseLock = false;
          break;
        case 3:
          this.dialogConfirmLock = false;
          break;
        case 4:
          this.refundDialogLock = false;
          break;
        case 5:
          this.refundDateDialogLock = false;
          break;
        default:
          break;
      }
    },
    // 退款审核 + 设置退款日期 按钮展示
    checkRefund(row, type) {
      let key = Math.floor(Number(row.examine_status) / 2);
      switch (type) {
        case 0:
          // 退款审核
          if (key < row.examine_json_list.length - 1 && [1, row.examine_uid].indexOf(this.$store.getters.userInfo.userid) !== -1) {
            return true;
          }
          break;
        case 1:
          // 设置退款日期
          if (key === row.examine_json_list.length - 1 && [1, row.examine_uid].indexOf(this.$store.getters.userInfo.userid) !== -1) {
            return true;
          }
          break;
        default:
          break;
      }
      return false;
    },
    // 打开报账文本弹窗
    openAccountDialog(row) {
      this.accountText = row.trade_text;
      this.dialogAccountLock = true;
    },
    // 到账确认
    confirmTrade(row) {
      this.currentRowId = row.id;
      this.dialogConfirmLock = true;
      this.onlyUpdateConfirmTime = false;
    },
    // 修改到账日期
    editConfirmTime(row) {
      this.confirmTime = (new Date(row.confirm_time)).getTime();
      this.currentRowId = row.id;
      this.dialogConfirmLock = true;
      this.onlyUpdateConfirmTime = true;
    },
    // 到账提交保存
    saveConfirmDialog() {
      const url = this.onlyUpdateConfirmTime ? '/finance/trade/saveConfirmTime' : '/finance/trade/financeConfirm';
      const msg = this.onlyUpdateConfirmTime ? '修改到账日期成功' : '报账操作成功';

      this.$http
        ._post({
          url: url,
          data: { id: this.currentRowId, confirmTime: this.confirmTime / 1000 }
        })
        .then(() => {
          this.$message.success(msg);
          this.dialogConfirmLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 拒绝报账打开
    refuseTrade(row) {
      this.currentRowId = row.id;
      this.dialogRefuseLock = true;
    },
    // 拒绝报账弹窗保存
    saveRefuseDialog() {
      this.$http
        ._post({
          url: '/finance/trade/financeRefuse',
          data: { id: this.currentRowId, message: this.refuseText }
        })
        .then(() => {
          this.$message.success('拒绝完成');
          this.dialogRefuseLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 打开退款信息弹窗
    openRefundDialog(row) {
      this.refundDialogLock = true;
      this.refundForm = Object.assign({}, row, { examine_message: '' });
    },
    // 打开设置退款日期
    openRefundDateDialog(row) {
      this.refundDateDialogLock = true;
      this.refundDateForm = Object.assign({}, row, { examine_message: '' });
    },
    // 退款审核保存
    refundInfoSave() {
      this.btnLoading = true;
      this.refundForm.examine_status = Number(this.refundForm.examine_status) + 2;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundForm
        })
        .then(() => {
          this.$message.success('审核成功');
          this.refundDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款审核拒绝
    refundInfoRefuse() {
      this.btnLoading = true;
      this.refundForm.examine_status = Number(this.refundForm.examine_status) + 1;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundForm
        })
        .then(() => {
          this.$message.success('已驳回');
          this.refundDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款日期保存
    refundDateSave() {
      this.btnLoading = true;
      this.refundDateForm.examine_status = Number(this.refundDateForm.examine_status) + 2;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundDateForm
        })
        .then(() => {
          this.$message.success('退款日期保存成功');
          this.refundDateDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款日期拒绝
    refundDateRefuse() {
      this.btnLoading = true;
      this.refundDateForm.examine_status = Number(this.refundDateForm.examine_status) + 1;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundDateForm
        })
        .then(() => {
          this.$message.success('已驳回');
          this.refundDateDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 打开流程单弹窗
    openProcessDialog (row) {
      this.$http
        ._post({
          url: '/finance/refund/findAllPoint',
          data: { id: row.id }
        })
        .then((res) => {
          this.processForm = res.data;
          this.processDialogLock = true;
        });
    },
    // 关闭流程单弹窗
    processDialogCancel() {
      this.processDialogLock = false;
    },
    // 获取页面数据
    getPageData() {
      this.$http._post({
        url: 'finance/order/find',
        data: { id: this.id, project_id: 10 }
      }).then(({ data }) => {
        this.formData = data;
      }).catch((res) => {
        console.log(res);
      });
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList
  },
  mounted() {
    this.getPageData();
  }
};
</script>
<style scoped lang="less">
  .info-manag-wrap{
    margin: 14px;
  }
  .info-manag-wrap .el-row{
    padding: 14px 0;
  }
  .info-manag-wrap .el-row span {
    color: #20a0ff;
  }
  .info-manage-process .el-row span{
    color: #20a0ff;
  }
  .process-dialog-wrap .title-area{
    position: relative;
  }
  .process-dialog-wrap .title-area i{
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
  .process-dialog-wrap{
    border: 1px solid #e8e8e8;
    padding-top: 10px;
  }
  .process-dialog-wrap .title-area{
    line-height: 40px;
    padding: 0 15px;
  }
  .process-dialog-wrap .process-dialog-area{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 10px 15px 15px;
  }
  .process-dialog-wrap .process-dialog-area .content-area{
    width: 50%;
    line-height: 25px;
    font-size: 14px;
  }
  .printTable{
    /deep/ .el-table__row td:last-of-type .cell {
      padding-right: 25px;
    }
  }
  .el-tooltip{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
</style>
